import Toast from '@/common/components/ui/toast'
import Dashboard from '@/common/components/layout/Dashboard'
import { ToastProvider } from '@/common/components/ui/toast/toast.provider'
import TablePurchaseRequisition from './components/tables/TablePurchaseRequisition'



export default function PurchaseRequisition() {
    return (
        <ToastProvider>
            <Dashboard>
                <TablePurchaseRequisition />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}
